









import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Components from '@/tenant/components';
import * as Common from '@/tenant/common';

@Component
export default class AtcCounterpart extends Vue {
  @Prop({ default: '' }) public title: string;
  @Prop({ default: null }) public value?: any | Common.IMasterItem;
  @Prop({ default: false }) public required: boolean;
  @Prop({ default: null }) public editor: Components.IEditor;
  @Prop({ default: true }) public enabled: boolean;
  @Prop({ default: true }) public isDirectEditEnabled: boolean;
  @Prop() public tooltip: string;
  @Prop({ default: Common.CategoryGroup.All }) public categoryGroup: Common.CategoryGroup;
  public isEdit: boolean = true;
  public validator: Components.ControlValidator = null;
  public isEnableCategory: boolean;

  public created() {
    this.isEnableCategory =  this.$api.useOperationFunction || this.$api.tenantVersion < Common.TenantVersions.Version_241220;
    //親Editorに登録する
    if (this.editor != null) this.editor.addControl(this);
  }
    destroyed(){
    if (this.editor != null) this.editor.removeControl(this);    
  }  
  public get internalValue(): string {
    return this.value;
  }
  public set internalValue(value: string) {
    // 親コンポーネント側で更新
    this.$emit('update:value', value);
    this.$emit('changed');
  }

   public queryProvider(search:string, perPage:number, currentPage:number){
    const query = new Common.CategoryMasterQuery(this.categoryGroup);
    query.search = search ? search : '';
    query.perPage = perPage;
    query.currentPage = currentPage;
    return query;
  }

  public convertToCategoryName(categoryType: number) {
    return this.$api.formatter.formatByList(categoryType,'categoryTypes');
  }
}
  
